import { FC } from 'react'
import { Box, Stack, TextField, Typography } from '@mui/material'
import { PerguntaElegibilidade, TAMANHO_MAXIMO_RESPOSTA_TEXTO } from '@/types/produto'

interface Props {
  perguntas: PerguntaElegibilidade[]
  /** Resposta por id da pergunta (string crua do campo). */
  respostas: Record<string, string>
  onChange: (perguntaId: string, resposta: string) => void
  disabled?: boolean
}

/**
 * Perguntas cadastrais do produto (as "perguntas de elegibilidade" do catálogo), respondidas
 * pelo consultor na etapa de documentos do cadastro da reserva (11/09 — antes ficavam na
 * seleção do produto; o negócio pediu que fossem na mesma jornada da inclusão dos documentos).
 *
 * Só apresentação: quem decide o que fazer com a resposta é o motor de elegibilidade
 * (Sim/Não, Número, Escolha) ou o operador/admin na validação (Texto livre).
 */
export const PerguntasCadastraisReserva: FC<Props> = ({ perguntas, respostas, onChange, disabled = false }) => (
  <Stack spacing={2}>
    {perguntas.map((pergunta) => {
      const valor = respostas[pergunta.id] ?? ''
      return (
        <Box key={pergunta.id}>
          {pergunta.tipoResposta === 'SIM_NAO' ? (
            <TextField
              label={pergunta.enunciado}
              select
              SelectProps={{ native: true }}
              value={valor}
              onChange={(e) => onChange(pergunta.id, e.target.value)}
              fullWidth
              disabled={disabled}
            >
              <option value="">Selecione…</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </TextField>
          ) : pergunta.tipoResposta === 'TEXTO' ? (
            <>
              {/* Texto livre (09/09): até 200 caracteres, contador visível. O motor não a
                  compara com nada — vai gravada na reserva e o operador/admin decide. */}
              <TextField
                label={pergunta.enunciado}
                value={valor}
                onChange={(e) => onChange(pergunta.id, e.target.value.slice(0, TAMANHO_MAXIMO_RESPOSTA_TEXTO))}
                inputProps={{ maxLength: TAMANHO_MAXIMO_RESPOSTA_TEXTO }}
                helperText={`${valor.length}/${TAMANHO_MAXIMO_RESPOSTA_TEXTO} caracteres`}
                fullWidth
                multiline
                minRows={2}
                disabled={disabled}
              />
              <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 0.5 }}>
                Resposta avaliada pelo time Originei na validação da reserva.
              </Typography>
            </>
          ) : pergunta.tipoResposta === 'ESCOLHA' ? (
            <TextField
              label={pergunta.enunciado}
              select
              SelectProps={{ native: true }}
              value={valor}
              onChange={(e) => onChange(pergunta.id, e.target.value)}
              fullWidth
              disabled={disabled}
            >
              <option value="">Selecione…</option>
              {pergunta.opcoes.map((o) => (
                <option key={o} value={o}>
                  {o}
                </option>
              ))}
            </TextField>
          ) : (
            <TextField
              label={pergunta.enunciado}
              type="number"
              value={valor}
              onChange={(e) => onChange(pergunta.id, e.target.value)}
              fullWidth
              disabled={disabled}
            />
          )}
        </Box>
      )
    })}
  </Stack>
)

export default PerguntasCadastraisReserva
